export const TEMPLATE_NAME_FIELD = 'name'

export const getDefaultValues = () => ({
  [TEMPLATE_NAME_FIELD]: '',
})
